import React from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Avatar, Dropdown, Menu } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { clearState, userSelector } from "../../features/authSlice";
import {
  LogoutOutlined,
  UserOutlined,
  HomeOutlined,
  CarOutlined,
  FileTextOutlined,
  AuditOutlined,
} from "@ant-design/icons";
import "./LayoutBanner.css";

const { Header } = Layout;

const LayoutBanner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(userSelector);

  const onLogOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    dispatch(clearState());
    navigate("/login");
  };


  const menuItems = [
    {
      key: "username",
      label: <strong>{user.name}</strong>,
      disabled: true,
    },
    {
      type: "divider",
    },
    ...(user.role === 'admin' ? [
      {
        key: "users-create",
        label: "Crear Usuario",
        icon: <UserOutlined />,
        onClick: () => navigate('/admin/users/new'),
      },
      {
        key: "users-manage",
        label: "Gestionar Usuarios",
        icon: <UserOutlined />,
        onClick: () => navigate('/admin/users/list/user'),
      },
      { type: "divider" },
      {
        key: "notary-documents",
        label: "Documentos del portal",
        icon: <FileTextOutlined />,
        onClick: () => navigate('/admin/notary-documents'),
      },
      {
        key: "announcements",
        label: "Anuncios del portal",
        icon: <FileTextOutlined />,
        onClick: () => navigate('/admin/announcements'),
      },
      {
        key: "repertory-index",
        label: "Índice de repertorios",
        icon: <FileTextOutlined />,
        onClick: () => navigate('/admin/repertory-index'),
      },
      {
        key: "portal-activity",
        label: "Actividad Portal",
        icon: <AuditOutlined />,
        onClick: () => navigate('/admin/portal-activity'),
      },
      { type: "divider" },
    ] : []),
    {
      key: "search-index",
      label: "Buscar Índice",
      icon: <FileTextOutlined />,
      onClick: () => navigate('/admin/search-index'),
    },
    { type: "divider" },
    {
      key: "logout",
      label: "Salir",
      icon: <LogoutOutlined />,
      onClick: onLogOut,
    },
  ];

  // Menú de navegación horizontal
  const navigationItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: 'Inicio',
      onClick: () => navigate('/admin')
    },
    {
      key: 'cartransfers',
      icon: <CarOutlined />,
      label: 'Transferencias',
      children: [
        {
          key: 'cartransfers-create',
          label: 'Crear',
          onClick: () => navigate('/admin/cartransfers/new')
        },
        {
          key: 'cartransfers-manage',
          label: 'Gestionar',
          onClick: () => navigate('/admin/cartransfers/list')
        }
      ]
    },
    {
      key: 'clients',
      icon: <UserOutlined />,
      label: 'Clientes',
      children: [
        {
          key: 'clients-personas',
          label: 'Personas',
          onClick: () => navigate('/admin/clients?tab=personas')
        },
        {
          key: 'clients-empresas',
          label: 'Empresas',
          onClick: () => navigate('/admin/clients?tab=empresas')
        },
        {
          key: 'clients-create',
          label: 'Crear cliente',
          onClick: () => navigate('/admin/users/new')
        }
      ]
    },
    {
      key: 'my-documents',
      icon: <FileTextOutlined />,
      label: 'Mis Documentos',
      onClick: () => navigate('/admin/my-documents')
    },
    {
      key: 'glossary',
      icon: <FileTextOutlined />,
      label: 'Generador de Glosas',
      onClick: () => navigate('/admin/glossary')
    }
  ];

  return (
    <Header
      className="header"
      style={{
        background: "#ffffff",
        borderBottom: "1px solid #e8e8e8",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 20px",
        height: "64px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img 
          src="/logo.png" 
          alt="Digital Notary" 
          style={{ 
            height: "40px", 
            cursor: "pointer"
          }}
          onClick={() => navigate('/admin')}
        />
      </div>

      {/* Menú de navegación horizontal */}
      <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <Menu
          mode="horizontal"
          items={navigationItems}
          style={{
            background: "transparent",
            border: "none",
            color: "#333333",
            minWidth: "600px",
          }}
        />
      </div>

      {/* Avatar del usuario */}
      <Dropdown menu={{ items: menuItems }} placement="bottomRight" trigger={["click"]}>
        <Avatar
          style={{
            backgroundColor: "#00a2ed",
            cursor: "pointer",
          }}
          icon={<UserOutlined />}
        />
      </Dropdown>
    </Header>
  );
};

export default LayoutBanner;